import { render } from "./copy-button.vue?vue&type=template&id=792fd205&scoped=true"
import script from "./copy-button.vue?vue&type=script&lang=js"
export * from "./copy-button.vue?vue&type=script&lang=js"

import "./copy-button.vue?vue&type=style&index=0&id=792fd205&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792fd205"]])

export default __exports__